// src/lib/managerWeek.js
// STATUS: active | UPDATED: 2026-09-24
// LOG:
//   2026-09-24  New. His weekly rhythm, the last section of manager.json with
//               nowhere to be done.
//
// See migration 0042. Pure helpers live at the bottom and carry no imports that
// node cannot load, per the import rule in CLAUDE.md.

import { supabase } from './supabase'
import { MANAGEMENT_SYSTEM } from '../content/manager'
import { mondayOf } from './managerWeekShape'

export * from './managerWeekShape'

export const RHYTHM = MANAGEMENT_SYSTEM.weeklyCoachingRhythm

export async function getWeek(userId, weekStart = mondayOf()) {
  if (!userId) return { data: null, error: null }
  const { data, error } = await supabase
    .from('manager_week')
    .select('id, week_start, items, note')
    .eq('user_id', userId)
    .eq('week_start', weekStart)
    .maybeSingle()
  return { data: data || null, error }
}

export async function saveWeek(userId, { weekStart = mondayOf(), items, note }) {
  if (!userId) return { error: 'Not signed in.' }
  const { error } = await supabase.from('manager_week').upsert(
    {
      user_id: userId,
      week_start: weekStart,
      items: items || [],
      note: String(note || '').trim() || null,
    },
    { onConflict: 'user_id,week_start' }
  )
  return { error: error ? error.message || String(error) : null }
}

export async function recentWeeks(userId, limit = 6) {
  if (!userId) return { data: [], error: null }
  const { data, error } = await supabase
    .from('manager_week')
    .select('week_start, items')
    .eq('user_id', userId)
    .order('week_start', { ascending: false })
    .limit(limit)
  return { data: data || [], error }
}
